import React from 'react';
import {observable, action, computed, makeObservable, runInAction, toJS} from 'mobx';
import {observer} from 'mobx-react';
import s from '../../s';
import * as util from '../../../util';
import ModalSimple from '../../../global/modal-simple';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/scrollbar';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/zoom';
import {Keyboard, Scrollbar, Navigation, Pagination, Zoom} from 'swiper/modules';

declare var __portal: IPortalSettings;

interface ISliderRealImagesProps {
    fullWidth?: boolean;
}

@observer
export default class SliderRealImages extends React.Component<ISliderRealImagesProps> {
    @observable zoom_index: number = -1;

    constructor(props) {
        super(props);
        this.toggleZoom = this.toggleZoom.bind(this);
        makeObservable(this);
        document.addEventListener('modal-closed', function (e: any) {
            if (e.detail === 'modal-prod-swiper-real') {
                s.ui.zoom_real_images = false;
            }
        });
    }

    @action
    toggleZoom = async (i: number) => {
        this.zoom_index = i;
        s.ui.zoom_real_images = true;

        var modalToggle = document.getElementById('modal-prod-swiper-real');
        if (modalToggle) {
            modalToggle.style.display = 'block';
        }
    };

    render() {
        if (!s.ready || !s.prod || !s.prod.real_images || s.prod.real_images.length < 3) {
            return;
        }
        return (
            <div>
                <Swiper
                    id="prod-swiper-real"
                    centeredSlides={false}
                    grabCursor={true}
                    zoom={false}
                    loop={true}
                    keyboard={{enabled: true}}
                    scrollbar={false}
                    navigation={true}
                    spaceBetween={10}
                    pagination={false}
                    height={125}
                    updateOnWindowResize={true}
                    slidesPerView={4}
                    breakpoints={{
                        650: {
                            slidesPerView: 5,
                            slidesPerGroup: 5,
                        },
                        600: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                        },
                        420: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            centeredSlides: false,
                        },

                        310: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            centeredSlides: true,
                        },
                        0: {
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            centeredSlides: true,
                        },
                    }}
                    modules={[Keyboard, Navigation, Zoom, Scrollbar]}
                    className="prod-swiper-real"
                    aria-roledescription="carousel"
                    role="region"
                    aria-label="Real product images"
                >
                    {s.prod.real_images.map((m, i: number) => (
                        <SwiperSlide
                            key={i}
                            tabIndex={0}
                            onClick={() => this.toggleZoom(i)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom(i);
                                }
                            }}
                        >
                            <div>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}/images/cached/rp/rp${m.id}_th250.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}/images/cached/rp/rp${m.id}_th250.jpg`}
                                        loading="lazy"
                                        alt={`Customer Image #${i}`}
                                        width={125}
                                        height={125}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {s.ui.zoom_real_images && (
                    <ModalSimple
                        id="modal-prod-swiper-real"
                        title="Product Zoom"
                        open={true}
                        maxWidth={'90%'}
                        close={() => (s.ui.zoom_real_images = false)}
                    >
                        <Swiper
                            id="prod-swiper-real-zoom"
                            // onInit={this.loadSwiperZoom}
                            slidesPerView={1}
                            initialSlide={this.zoom_index}
                            centeredSlides={true}
                            grabCursor={true}
                            zoom={true}
                            loop={true}
                            keyboard={{
                                enabled: true,
                            }}
                            scrollbar={true}
                            navigation={true}
                            pagination={false}
                            modules={[Keyboard, Scrollbar, Navigation, Zoom]}
                            aria-roledescription="carousel"
                            role="region"
                            aria-label="Real product images"
                        >
                            {s.prod.real_images.map((m, i) => (
                                <SwiperSlide
                                    key={i}
                                    virtualIndex={i}
                                    role="button"
                                    aria-label="View Real Customer Image"
                                >
                                    <picture className="swiper-zoom-container">
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}/images/cached/rp/rp${m.id}_th1024.webp`}
                                        />
                                        <img
                                            src={`https://${s.Portal.CDNDomain}/images/cached/rp/rp${m.id}_th1024.jpg`}
                                            loading="lazy"
                                            alt={`Customer Image #${i}`}
                                            width={1024}
                                            height={1024}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                        />
                                    </picture>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </ModalSimple>
                )}
            </div>
        );
    }
}
